import {
    FETCH_DASHBOARD_USER,
    SAVE_DASHBOARD_USER,
    DELETE_DASHBOARD_USER,
} from '../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_USER:
            return action.payload;
        case SAVE_DASHBOARD_USER:
            if (action.meta && action.meta.userId) {
                return state.map(user => user.id === action.meta.userId ? action.payload : user);
            }
            return state.concat(action.payload);
        case DELETE_DASHBOARD_USER:
            return state.filter(user => user.id !== action.meta.userId);
        default:
            return state;
    }
};
